import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import Button from "../../../components/Common/Button";
import "./style.scss";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {getCompanyById, getRm} from "../../../api/company";
import {CompanyRmI} from "../../../db/models/company/rm";
import {ClipLoader} from "react-spinners";
import {incrementCompanyRmStatsView} from "../../../api/company/rmStats";
import {ROUTES} from "../../../db/models/const";
import {CompanyInterface} from "../../../db/models/company/company";
import {selectEmail} from "../../../slices/auth";
import {selectUser} from "../../../slices/profile";
import {updateCompanyRmWaiting} from "../../../api/company/rmWaiting";
import {openAlert} from "../../../slices/alert";

const StudentRmComing = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const history = useHistory();
    const {rmId} = useParams<any>();
    const [rm, setRm] = useState<CompanyRmI>();
    const [company, setCompany] = useState<CompanyInterface>();
    const [loading, setLoading] = useState<boolean>();
    const email = useSelector(selectEmail);
    const user = useSelector(selectUser);

    const handleGoToFeed = () => {
        history.push(ROUTES.FEED);
    };

    const handleNotify = () => {
        updateCompanyRmWaiting(rmId, email)
            .then(() =>
                dispatch(openAlert({type: "success", message: t("alert_waitingList_updated")}))
            )
            .catch(() =>
                dispatch(
                    openAlert({type: "error", message: t("alert_generic_error")})
                )
            );
    };

    useEffect(() => {
        if (!rmId) {
            history.push("/");
            return;
        }

        setLoading(true);
        getRm(rmId)?.then((rm) => {
            if (!rm) {
                history.push(ROUTES.ME);
                return;
            } else {
                if (rm?.coming) {
                    setRm(rm);
                    if (!user?.demo) incrementCompanyRmStatsView(rmId);

                    getCompanyById(rm.companyId).then((company: any) => {
                        setCompany(company);
                        setLoading(false);
                    });
                } else {
                    // if rm does not have the coming soon flag then redirect to rm page with all info
                    history.push(ROUTES.STUDENT_RM.replace(":rmId", rm.id));
                    return;
                }
            }
        });
    }, [rmId]);

    return (
        <div className="studentRmComing card">
            {loading && <ClipLoader size={50} color={"#7400b8"} loading={true}/>}
            {!loading && (
                <>
                    <p className="studentRmComing__comingSoon">Coming soon</p>
                    <h2>{rm?.name}</h2>
                    <h3>{company?.name}</h3>
                    <p className="studentRmComing__msg">{t("student_coming_msg")}</p>
                    <div className="studentRmComing__notifyBtn">
                        <Button type="button" filled onClick={() => handleNotify()}>
                            {t("student_coming_notifyMeBtn")}
                        </Button>
                    </div>
                    <Button type="button" onClick={() => handleGoToFeed()} light>
                        <ArrowBackIcon/>
                        <div className="text">{t("student_coming_backBtn")}</div>
                    </Button>
                </>
            )}
        </div>
    );
};

export default StudentRmComing;
